import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * A component that safely displays images and prevents PDFs from being used
 */
const SafeImage = ({ src, alt, style = {}, ...props }) => {
  const [hasError, setHasError] = useState(false);
  
  // Check if the source is a valid image (not a PDF)
  const isValidImage = () => {
    if (!src) return false;
    
    const fileExtension = src.split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    
    return imageExtensions.includes(fileExtension);
  };
  
  // If src is not a valid image or there was a loading error, show placeholder
  if (!isValidImage() || hasError) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          height: style.height || 200,
          width: style.width || '100%',
          ...style
        }}
        {...props}
      >
        <Typography variant="body2" color="text.secondary">
          No Image Available
        </Typography>
      </Box>
    );
  }
  
  // If it's a valid image, render it
  return (
    <img
      src={src}
      alt={alt || "Product image"}
      style={style}
      onError={() => setHasError(true)}
      {...props}
    />
  );
};

export default SafeImage;
